// extracted by mini-css-extract-plugin
export default {"zoomControls":"Dva-z","zoomControlButton":"Eva-z","zoomBanner":"Fva-z","bannerButton":"Gva-z","imageButton":"Hva-z"};